import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';

@Component({
  selector: 'app-custom-order-list',
  templateUrl: './custom-order-list.component.html'
})
export class CustomOrderListComponent  implements OnDestroy{

  @Input() listItems: IItemWishList[] = [];
  @Output() listChanges = new EventEmitter<boolean>();

  private notificaction?: Subscription;
  constructor(){}

  ngOnDestroy(): void {
    if(this.notificaction){
      this.notificaction.unsubscribe();
    }
  }
}
